import { render } from "./headerCommande.vue?vue&type=template&id=2175f7ed"
import script from "./headerCommande.vue?vue&type=script&lang=ts"
export * from "./headerCommande.vue?vue&type=script&lang=ts"
script.render = render

export default script